import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from '../../../store/middlewares/axios';
import styles from './VerifyLoginPage.module.scss';

function VerifyLoginPage() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading');

    const email = searchParams.get('email');
    const hash = searchParams.get('hash');
    const time = searchParams.get('time');

    useEffect(() => {
        if (email && hash && time) {
            axios({
                url: '/api/user/verify_by_link',
                method: 'POST',
                data: {
                    login: email,
                    time: time,
                    hash: hash,
                },
            })
                .then(() => setStatus('success'))
                .catch(() => setStatus('error'));
        } else {
            setStatus('error');
        }
    }, []);

    return (
        <div className={styles.container}>
            <h1 className={styles.logo}>Spara</h1>
            {status === 'loading' && (
                <p className={styles.message}>Staðfesti netfang...</p>
            )}
            {status === 'success' && (
                <p className={styles.message}>Netfang þitt hefur verið staðfest!</p>
            )}
            {status === 'error' && (
                <p className={`${styles.message} ${styles.error}`}>
                    Staðfesting mistókst. Tengillinn kann að vera útrunninn eða ógildur.
                </p>
            )}
        </div>
    );
}

export default VerifyLoginPage;
